import { deleteSlider, getSlidersPanel} from "../../services/SlidersService";
import { SlidersContext } from "./SlidersContext"

export const SlidersState = ({ children }) => {
    const getSlidersPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getSlidersPanel(searchTerm,numPagina, filas);
        return res
    }

    const deleteSliderData = async (body,searchTerm,numPagina, filas) => {
        const res = await deleteSlider(body)
        if (res) getSlidersPanelData(searchTerm,numPagina, filas)
        return res
    }

    return <SlidersContext.Provider value={{
        deleteSliderData,
        getSlidersPanelData,
    }} >
        {children}
    </SlidersContext.Provider>
}